/* eslint-disable no-restricted-imports */
import React, { useRef } from 'react';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
} from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';

type DeleteGoalDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  goalTitle: string;
  isLoading: boolean;
};

export const DeleteGoalDialog: React.FC<DeleteGoalDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  goalTitle,
  isLoading,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader
            fontFamily="marketingPage"
            fontWeight="bold"
            fontSize="lg"
            color="text.title">
            Delete Goal
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Are you sure you want to delete <strong>{goalTitle}</strong>? This
              action cannot be undone.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              buttonName="cancel-delete-goal"
              variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              isLoading={isLoading}
              buttonName="confirm-delete-goal"
              sx={{
                bg: 'background.red.500',
                color: 'white',
                _hover: { bg: 'red.600' },
              }}>
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
